import {newsletterSegmentEdit_template} from "./newsletterSegmentEdit_template";

export class newsletterSegmentView_template extends newsletterSegmentEdit_template {
    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="form-header">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn icon i-back" type="button">Go Back</button>
                <h3 class="form-title" data-bind="text: title"></h3>
                <div class="w-btn">
                    <button data-bind="visible: permissions()['newsletter_segments'] && permissions()['newsletter_segments'].write, event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Segment</button>
                </div>
            </div>
            <div class="w-form-body">
                <div class="form-body full-width">
                    <strong class="form-sub-title">Segment Info</strong>
                    <div class="form-group">
                        <dl class="double-list newsletter-segment-info-list">
                            <dt>
                                <span>Title</span>
                            </dt>
                            <dd>
                                <span data-bind="text: title"></span>
                            </dd>
                            <dt>
                                <span>Active</span>
                            </dt>
                            <dd>
                                <span data-bind="text: isActive() ? 'Yes' : 'No'"></span>
                            </dd>
                        </dl>
                    </div>

                    <strong class="form-sub-title">Criteria</strong>
                    ${this.targetingBuilder.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "newsletterSegmentView_template";
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterSegmentView_template.ts